import type { ResteChargeContribution } from '../shared/ResteChargeContribution'

export const ResteChargeContributionTypePublicPermanent: ReadonlyArray<
  Extract<ResteChargeContribution, 'Investissement'>
> = ['Investissement'] as const

export const ResteChargeContributionTypePublicInterimaire: ReadonlyArray<
  Extract<ResteChargeContribution, 'Investissement' | 'FPE'>
> = ['Investissement', 'FPE'] as const

export const ResteChargeContributionTypePublicInterimaireStagiaireCDI: ReadonlyArray<
  Extract<ResteChargeContribution, 'Investissement' | 'FPE' | 'FPE10PourcentCDII'>
> = ['Investissement', 'FPE', 'FPE10PourcentCDII'] as const

export type ResteChargeContributionTypePublicPermanent = (typeof ResteChargeContributionTypePublicPermanent)[number]
export type ResteChargeContributionTypePublicInterimaire = (typeof ResteChargeContributionTypePublicInterimaire)[number]
export type ResteChargeContributionTypePublicInterimaireStagiaireCDI = (typeof ResteChargeContributionTypePublicInterimaireStagiaireCDI)[number]
